import React from 'react';
import { Col, Button, Modal, Row, Space } from 'antd';
import { DeleteOutlined, EditOutlined } from '@ant-design/icons';
import { DangerButton, Label } from 'components/common';
import { SmartNumberInput, SmartSpace, playSound } from 'components/Sales/Smart/SmartComponent';
import { PoRecvActionType as PRAction } from './context';
import { getItemReceivingMaxQty, isLotAvailableOnItem } from '.';

type Props = ReduxStateProps & {
  editable?: boolean;
};

const RecvItemList = (props: Props) => {
  const deleteReceiveItem = (idx: number) => {
    const { dispatch, state } = props;
    const item = state.recvItems[idx];

    Modal.confirm({
      title: 'Confirm',
      okText: 'Yes',
      cancelText: 'No',
      //centered: true,
      content: `Do you want to delete this item[${item.sku}]?`,
      onOk() {
        const recvItems = [ ...state.recvItems ];
        //console.log('di', idx);
        recvItems.splice(idx, 1);
        dispatch({ type: PRAction.SetRecvItems, params: [...recvItems] });
      },
    });
  };

  const onItemRecvValueChange = (
    item: StringKAnyVPair,
    rQty: number,
    onOk: Function,
    onError: Function,
  ) => {
    const isOk = validateRecvQtyForItem(item, rQty);
    const maxQty = getItemReceivingMaxQty(props.state.recvItems, item);

    //console.log('rqty', rQty);
    if (isOk) {
      onOk(rQty);
    } else {
      onError(rQty);
      playSound('error');
      Modal.error({
        title: 'Error',
        content: `It can accept a maximum of ${maxQty}. Cannot exceed total quatity[${item.poQty}]`,
        okButtonProps: {
        //size: 'large',
        },
      });
    }
  };

  const openEditReceiveQtyDialog = (idx: number) => {
    const { dispatch, state } = props;
    const item = state.recvItems[idx];
    const maxQty = getItemReceivingMaxQty(state.recvItems, item);
    const oQty = item._receivingQty;
    let isLastQtyError = false;
    let rQty = item._receivingQty;

    Modal.confirm({
      bodyStyle: { padding: 16 },
      title: 'Edit Receive Qty',
      //okText: 'Yes',
      //cancelText: 'No',
      //centered: true,
      content: (
        <SmartSpace className="mb-5">
          <Row className="mt-15" justify="center">
            <SmartNumberInput
              className="num-input nw-80 h-50"
              defaultValue={rQty}
              //key={`recv-input${itemRecvInputVersion}`}
              //max={getItemReceivingMaxQty(state.recvItems, item)}
              min={1}
              onChange={val => onItemRecvValueChange(item, Number(val), (qty: number) => {rQty = qty; isLastQtyError = false;}, (qty: number) => {rQty = qty; isLastQtyError = true;})}
            />
          </Row>
        </SmartSpace>
      ),
      icon: null,
      onOk(close: Function) {
        const recvItems = [ ...state.recvItems ];
        //const nQty = getMatchItemReceivingQty(recvItems, item.sku || item.upc);
        //console.log('di', close, idx, rQty);
        //if (nQty + rQty + item.humanReceiveQty > item.poQty) {
        if (rQty < 1) {
          Modal.error({
            title: 'Error',
            content: 'It can accept a minimum of 1.',
            okButtonProps: {
            //size: 'large',
            },
          });
          return;
        }

        if (state.enablePOReceiveControl && rQty > maxQty) {
          //item._receivingQty = oQty;
          //dispatch({ type: PRAction.SetRecvItems, params: [...recvItems] });
          playSound('error');
          Modal.error({
            title: 'Error',
            content: `It can accept a maximum of ${maxQty}. Cannot exceed total quatity[${item.poQty}]`,
            okButtonProps: {
            //size: 'large',
            },
          });
        } else {
          const recvQty = isLastQtyError ? oQty : rQty;

          item._receivingQty = recvQty;
          item._baseQty = item.uomRate * recvQty;
          dispatch({ type: PRAction.SetRecvItems, params: [...recvItems] });
          playSound('bell');
          close();
        }
      },
    });
  };

  const renderReceivingItems = (items: StringKAnyVPair[]) => {
    return items.map((e, i) => {
      return (
        <div
          className="ant-card mb-5 tr-odd-even w-p100"
          key={`${e._recvUuid}`}
        >
          <div className="ant-card-body ant-card-bordered b-r-10 card-body-p2 w-p100">
            <Row>
              <Col span={12} className="r-i-cell p-4">
                <Label className="tail-colon1" theme={{fontSize: '1.0em'}}>SKU</Label>
                <Label className="label-grey">{e.sku}</Label>
              </Col>
              <Col span={12} className="r-i-cell p-4">
                <Label className="tail-colon1" theme={{fontSize: '1.0em'}}>UPC</Label>
                <Label className="label-grey">{e.upc}</Label>
              </Col>
              <Col span={12} className="r-i-cell p-4">
                <Label className="tail-colon1" theme={{fontSize: '1.0em'}}>Location</Label>
                <Label className="label-grey">{e.receivingLocationCode}</Label>
              </Col>
              {isLotAvailableOnItem(props.state, e) && (
                <Col span={12} className="r-i-cell p-4">
                  <Label className="tail-colon1" theme={{fontSize: '1.0em'}}>LOT#</Label>
                  <Label className="label-grey">{e._receivingLot}</Label>
                </Col>
              )}
              {props.state.enableUom && (
                <Col span={12} className="r-i-cell p-4">
                  <Label className="tail-colon1" theme={{fontSize: '1.0em'}}>UOM</Label>
                  <Label className="label-grey">{`${e.uom}(${e.uomRate})`}</Label>
                </Col>
              )}
              <Col span={12} className="r-i-cell p-4">
                <Label className="tail-colon1" theme={{fontSize: '1.0em'}}>Receive Qty</Label>
                <Label className="label-grey">{e._receivingQty}</Label>
              </Col>
              {props.state.enableUom && (
                <Col span={12} className="r-i-cell p-4">
                  <Label className="tail-colon1" theme={{fontSize: '1.0em'}}>Base Qty</Label>
                  <Label className="label-grey">{(e._baseQty || 0)}</Label>
                </Col>
              )}
            </Row>
            {props.editable && <Row className="b-t-bordered" justify="end">
              <Space className="p-4-2-2" size={12}>
                <DangerButton
                  onClick={() => deleteReceiveItem(i)}
                  size="small"
                >
                  <DeleteOutlined />
                  Delete
                </DangerButton>
                <Button
                  onClick={() => openEditReceiveQtyDialog(i)}
                  size="small"
                  type="primary"
                >
                  <EditOutlined />
                  Edit
                </Button>
              </Space>
            </Row>}
          </div>
        </div>
      );
    });
  };

  const validateRecvQtyForItem = (
    item: StringKAnyVPair,
    rQty: number,
  ) => {
    const { state } = props;
    const nQty = getItemReceivingMaxQty(props.state.recvItems, item);
    let ret = true;

    //if (nQty + rQty + item.humanReceiveQty > item.poQty) {
    if (state.enablePOReceiveControl) {
      if (nQty < rQty) {
        //console.log('err', rQty, nQty);
        ret = false;
      }
    }

    return ret;
  };

  return (<>
    {renderReceivingItems(props.state.recvItems)}
  </>);
};

export default RecvItemList;
